var poll_default = {
  "fontElementMap": "_72yCG",
  "container": "_8p4Hh",
  "fullscreen": "cFJ-k",
  "background_overlay": "u-QSR",
  "with_image": "WRVyS",
  "options": "H6RbV",
  "webview": "JONAI",
  "grid": "Vgyk5",
  "option": "k52I8",
  "cta_button": "Zmv5s",
  "add_option": "_65a0m",
  "see_more": "yP0n4",
  "list": "mq1o9",
  "column": "Pz8Uc",
  "additional_note": "_4kcwW",
  "spinner": "yN7Fv",
  "spin": "SJsGN",
  "shown": "IkKHg",
  "error": "WbI6h"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
